import Loading from 'components/Loading';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map } from 'immutable';
import { Link } from 'redux-little-router';

import { routeMap } from 'router';
import Warning from 'components/Warning';

export default class RedirectToLKIP extends Component {
  static propTypes = {
    lkIp: PropTypes.instanceOf(Map).isRequired,
    dispatch: PropTypes.func,
  };

  state = {
    hasError: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { lkIp } = nextProps;
    const data = lkIp.get('data');
    if (data && data.lkipEnable && data.lkipToken) {
      location.href = `https://lkip.nalog.ru/api/lk2/${data.lkipToken}`;
    } else if (data && !data.lkipEnable) {
      this.setState({ hasError: true });
    }
  }

  renderError = () => {
    return (
      <div className="white-block white-block__pad20">
        <Warning />
      </div>
    );
  };

  render() {
    const { lkIp } = this.props;
    const loading = lkIp.get('loading') || !lkIp.get('data');
    const error = lkIp.get('error') || this.state.hasError;

    return (
      <div className="main-page">
        <div className="main-page_bg" />
        <div className="header-wrapper header-wrapper__main">
          <div className="header header__main content">
            <a className="header-title">
              <span className="header-title_icon" />
              <span className="header-title_text">
                Личный кабинет
                <br /> налогоплательщика
              </span>
            </a>
            <div className="header_right">
              <div className="header_links">
                <span
                  className="white"
                  style={{ padding: '0 20px 5px', display: 'inline-block', float: 'right' }}
                >
                  Контакт-центр
                </span>
                <a href="tel:8-800-222-2222" className="phone">
                  8-800-222-2222
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="main-page_center">
          <div className="main-page_cell">
            <div className="content">
              <div className="main-page_row main-page_row__small">
                {error ? this.renderError() : null}
                {loading && !error ? <Loading isLight={true} /> : null}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-wrapper">
          <div className="footer footer__main content">
            <div className="footer_left">
              <span className="mobile-hide">
                При наличии вопросов по работе сервиса Вы можете воспользоваться режимом&nbsp;
              </span>
              <Link href={routeMap.faq} className="link white link__underline">
                «Вопрос-ответ»
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
